var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('form', {
    attrs: {
      "data-vv-scope": "uploadform"
    }
  }, [_c('b-card', [
    [_c('div', [(_vm.downloadTemplateMessage != '') ? _c('div', [_c('b-alert', {
      staticClass: "col-lg-12",
      attrs: {
        "show": "",
        "variant": "success"
      }
    }, [_vm._v(_vm._s(_vm.downloadTemplateMessage))])], 1) : _vm._e(), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "flex"
      }
    }, [_c('div', {
      staticClass: "firstDiv",
      class: {
        'col-lg-12': _vm.activeDiv === 1,
        'col-lg-4': _vm.activeDiv === 2
      }
    }, [_c('i', {
      staticClass: "fa fa-upload fa-3x",
      staticStyle: {
        "color": "#569e56"
      },
      attrs: {
        "aria-hidden": "true"
      }
    }), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v("To Download Sample File Template "), _c('span', {
      staticClass: "link-style",
      on: {
        "click": _vm.createTemplate
      }
    }, [_vm._v("Click\n                                    me")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('span', [_vm._v("Please Select Excel File ")]), _vm._v(" "), _c('div', {
      staticClass: "file-upload"
    }, [_c('label', {
      attrs: {
        "for": "uploadFtcReviewedDeposit"
      }
    }, [_c('a', {
      staticClass: "-btn btn-primary",
      staticStyle: {
        "font-size": "15px"
      },
      attrs: {
        "title": "Choose File to Upload"
      }
    }, [_vm._v("Choose\n                                        File "), _c('i', {
      staticClass: "fa fa-upload",
      staticStyle: {
        "color": "#fff"
      }
    })])]), _vm._v(" "), _c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      ref: "files",
      attrs: {
        "id": "uploadFtcReviewedDeposit",
        "name": "uploadFtcReviewedDeposit",
        "type": "file",
        "disabled": _vm.disabled
      },
      on: {
        "change": _vm.uploadBookingData
      }
    }), _c('br'), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('uploadform.uploadBookingData')),
        expression: "errors.has('uploadform.uploadBookingData')"
      }],
      staticClass: "text-danger errormsg"
    }, [_vm._v("Choose file\n                                    to upload")])]), _vm._v(" "), (_vm.showprogress) ? _c('span', [_c('span', [_vm._v("Selected File Name")]), _vm._v(": " + _vm._s(_vm.filename) + " ")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "actionButton form-group text-center"
    }, [_c('button', {
      staticClass: "-btn btn-success",
      attrs: {
        "type": "button",
        "title": "Submit",
        "disabled": _vm.disabled
      },
      on: {
        "click": _vm.submitFile
      }
    }, [_vm._v("Submit "), _c('i', {
      staticClass: "fa fa-save"
    })]), _vm._v("  \n                                "), _c('button', {
      staticClass: "-btn btn-danger",
      attrs: {
        "type": "button",
        "title": "Reset"
      },
      on: {
        "click": _vm.resetform
      }
    }, [_vm._v("Reset "), _c('i', {
      staticClass: "fa fa-refresh"
    })])])]), _vm._v(" "), (_vm.activeDiv === 2) ? _c('div', {
      staticClass: "col-lg-8"
    }, [_c('div', [_c('div', {
      staticClass: "overlayChild"
    }, [_c('div', {
      staticClass: "head"
    }, [_c('p', {
      staticClass: "head_1"
    }, [_vm._v("Downloading "), _c('span', [_vm._v("Please Wait ...")])]), _vm._v(" "), _c('p', {
      staticClass: "head_2"
    }, [_vm._v("This Will Take Some Time. Do Not Refresh Page ")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('ul', [_c('li', [_c('i', {
      staticClass: "icon fa fa-th-list",
      class: {
        'zoom-in-out-box_Icon': _vm.activeStep_Zoom_1
      }
    }), _vm._v(" "), _c('div', {
      class: {
        stepActive: _vm.activeStep_1,
        'stepProgress': true,
        'one': true
      }
    }, [_c('p', [_vm._v("1")]), _vm._v(" "), _c('i', {
      staticClass: "fa fa-check",
      class: {
        'zoom-in-out-box': _vm.activeStep_Zoom_1
      }
    })]), _vm._v(" "), _c('small', {
      class: {
        processingText: _vm.activeStep_1
      }
    }, [_vm._v(_vm._s(_vm.stepText_1))]), _vm._v(" "), _c('p', {
      staticClass: "text"
    }, [_vm._v("Upload File")])]), _vm._v(" "), _c('li', [_c('i', {
      staticClass: "icon fa fa-download",
      class: {
        'zoom-in-out-box_Icon': _vm.activeStep_Zoom_2
      },
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" "), _c('div', {
      class: {
        stepActive: _vm.activeStep_2,
        'stepProgress': true
      }
    }, [_c('p', [_vm._v("2")]), _vm._v(" "), _c('i', {
      staticClass: "fa fa-check",
      class: {
        'zoom-in-out-box': _vm.activeStep_Zoom_2
      }
    })]), _vm._v(" "), _c('small', {
      class: {
        processingText: _vm.activeStep_2
      }
    }, [_vm._v(_vm._s(_vm.stepText_2))]), _vm._v(" "), _c('p', {
      staticClass: "text"
    }, [_vm._v("Data Validation")])]), _vm._v(" "), _c('li', [_c('i', {
      staticClass: "icon fa fa-database",
      class: {
        'zoom-in-out-box_Icon': _vm.activeStep_Zoom_3
      },
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" "), _c('div', {
      class: {
        stepActive: _vm.activeStep_3,
        'stepProgress': true
      }
    }, [_c('p', [_vm._v("3")]), _vm._v(" "), _c('i', {
      staticClass: "fa fa-check",
      class: {
        'zoom-in-out-box': _vm.activeStep_Zoom_3
      }
    })]), _vm._v(" "), _c('small', {
      class: {
        processingText: _vm.activeStep_3
      }
    }, [_vm._v(_vm._s(_vm.stepText_3))]), _vm._v(" "), _c('p', {
      staticClass: "text"
    }, [_vm._v("Approval Progress")])]), _vm._v(" "), _c('li', [_c('i', {
      staticClass: "icon fa fa-check-square-o",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" "), _c('div', {
      class: {
        stepActive: _vm.activeStep_4,
        'stepProgress': true
      }
    }, [_c('p', [_vm._v("4")]), _vm._v(" "), _c('i', {
      staticClass: "fa fa-check",
      class: {
        'zoom-in-out-box': _vm.activeStep_Zoom_4
      }
    })]), _vm._v(" "), _c('small', {
      class: {
        processingText: _vm.activeStep_4
      }
    }, [_vm._v(_vm._s(_vm.stepText_4))]), _vm._v(" "), _c('p', {
      staticClass: "text"
    }, [_vm._v("Successfully Fetched")])])]), _vm._v(" "), _c('div', {
      staticClass: "progress-bar1",
      class: {
        'completed': _vm.progressValue === 100
      },
      style: ({
        width: _vm.progressValue + '%'
      })
    })])])]) : _vm._e()])])]
  ], 2), _vm._v(" "), _c('b-card', [_c('fieldset', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showresult == true),
      expression: "showresult==true"
    }]
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h4', {
    staticClass: "header",
    staticStyle: {
      "padding-top": "5px"
    }
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Upload Details")])]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("Total Records")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Valid Records")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Invalid Records")])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-center"
  }, [_c('b-badge', {
    staticClass: "infoBadge",
    attrs: {
      "pill": "",
      "variant": "success"
    }
  }, [_vm._v(_vm._s(_vm.totalRecords))])], 1), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('span', {
    staticStyle: {
      "text-decoration-line": "underline",
      "cursor": "pointer",
      "color": "blue"
    },
    attrs: {
      "title": "Vaild Records"
    },
    on: {
      "click": function($event) {
        _vm.openUploadResultData('valid')
      }
    }
  }, [_c('b-badge', {
    staticClass: "infoBadge",
    attrs: {
      "pill": "",
      "variant": "success"
    }
  }, [_vm._v(_vm._s(_vm.successRecords ? _vm.successRecords.length : 0) + "\n                                    ")])], 1)]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('span', {
    staticStyle: {
      "text-decoration-line": "underline",
      "cursor": "pointer",
      "color": "blue"
    },
    attrs: {
      "title": "Invaild Records"
    },
    on: {
      "click": function($event) {
        _vm.openUploadResultData('invalid')
      }
    }
  }, [_c('b-badge', {
    staticClass: "infoBadge",
    attrs: {
      "pill": "",
      "variant": "danger"
    }
  }, [_vm._v(_vm._s(_vm.failedRecords.length))])], 1)])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('fieldset', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showuploadresult == true),
      expression: "showuploadresult==true"
    }]
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showimportbutton == true),
      expression: "showimportbutton==true"
    }],
    staticClass: "-btn btn-warning",
    staticStyle: {
      "color": "white",
      "background-color": "#ff9800",
      "cursor": "pointer"
    },
    attrs: {
      "type": "button",
      "title": "Confirm & Upload Record",
      "disabled": _vm.disableimport
    },
    on: {
      "click": _vm.importValidRecords
    }
  }, [_vm._v("Confirm & Upload Record "), _c('i', {
    staticClass: "fa fa-arrow-circle-down",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.showuploadresult) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered tbl datatables",
    staticStyle: {
      "table-layout": "fixed",
      "width": "100%"
    }
  }, [_c('thead', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("Deposit Slip ID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Destination Branch")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Waybill Number")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Upload Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("WayBill Collectible Amount")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Deposit Amount")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Deposit Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Deposit by")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Finance Review Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "30%"
    }
  }, [_vm._v("Message")])]), _vm._v(" "), _c('tbody', _vm._l((_vm.uploadResultData), function(data, ind) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.depositid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.hubid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.awb))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.createddate))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.awbpendingamt))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.awbsettledamt))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.createddate))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.depositstauts))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.depositby))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.financereviewedstatus))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.comment))])])
  }))])])]) : _vm._e()])])])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f89bb34","hasScoped":true}!./src/modules/firstAndLastmilemanagement/views/bulkreviewftcdeposit/bulkreviewftcdeposit.component.html
// module id = 1884
// module chunks = 3